//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum ConnectVendorType { // should match COLLECTION_SETTINGS.CONNECT_VENDOR in constants.angular.js
  All = 'All',
}
